module.exports = __webpack_public_path__ + "img/vibrate.6e038f01.svg";